import {
  ChevronDownIcon,
  ChevronRightIcon,
} from '@langchain/untitled-ui-icons';

import { IconButton } from '@/design-system';

export const ChevronToggle = ({
  isAllCollapsed,
  setIsAllCollapsed,
}: {
  isAllCollapsed: boolean;
  setIsAllCollapsed: () => void;
}) => {
  return (
    <IconButton
      onClick={setIsAllCollapsed}
      variant="plain"
      label={isAllCollapsed ? 'Expand all' : 'Collapse all'}
      size="sm"
      color="secondary"
      icon={isAllCollapsed ? ChevronRightIcon : ChevronDownIcon}
    />
  );
};
